module.exports = __webpack_public_path__ + "img/tajwid2.1406e380.png";